import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'TEACHER_SLOTS_GET_ALL',
  GET_ALL_SUCCESS: 'TEACHER_SLOTS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'TEACHER_SLOTS_GET_ALL_FAILURE',

  GET: 'TEACHER_SLOTS_GET',
  GET_SUCCESS: 'TEACHER_SLOTS_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_SLOTS_GET_FAILURE',

  POST: 'TEACHER_SLOTS_POST',
  POST_SUCCESS: 'TEACHER_SLOTS_POST_SUCCESS',
  POST_FAILURE: 'TEACHER_SLOTS_POST_FAILURE',

  PATCH: 'TEACHER_SLOTS_PATCH',
  PATCH_SUCCESS: 'TEACHER_SLOTS_PATCH_SUCCESS',
  PATCH_FAILURE: 'TEACHER_SLOTS_PATCH_FAILURE',

  INVALIDATE_ITEM: 'TEACHER_SLOTS_INVALIDATE_ITEM',
};

export const get = actions.get(
  (teacherId, query, meta) => `${BASE_URL}/classroom/teacher-slots/?${stringify(meta)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const patch = actions.patch(
  teacherSlotId => `${BASE_URL}/classroom/teacher-slots/${teacherSlotId}`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { id },
  });
};
